module.exports = __webpack_public_path__ + "static/img/plain_screen_icon.660fc8d1.svg";